import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import {
    commonCopySourceAdapts,
    CopySourceAdapter
} from 'app/model/adapters/activities/copysource/copysource.adapter';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { GenericCDataCopySource } from 'shell-models-lib';

const reservedSourcePropertyNames = new Set([
    'type',
    'query',
    'additionalColumns',
    'datasetSettings',
    'changeReadStrategy'
]);

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GenericCDataCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class GenericCDataCopySourceAdapter extends CopySourceAdapter<
    GenericCDataCopySource,
    Model.GenericCDataSource
> {
    protected override async _toResource(
        copySource: GenericCDataCopySource
    ): Promise<Model.GenericCDataSource> {
        const resource = this._toTabularResource(
            copySource,
            Metamodel.modelFor(GenericCDataCopySource).name
        ) as Model.GenericCDataSource;
        copySource.additionalFields.forEach(({ key, value }) => {
            if (key && !reservedSourcePropertyNames.has(key)) {
                resource[key] = value;
            }
        });
        return resource;
    }

    protected override async _toModel(
        resource: Model.GenericCDataSource,
        copyActivity: CopyActivity
    ): Promise<GenericCDataCopySource> {
        const copySource = this._toTabularModel(
            resource,
            copyActivity,
            GenericCDataCopySource.MODEL
        ) as GenericCDataCopySource;
        copySource.additionalFields = Object.entries(resource)
            .filter(([key]) => !reservedSourcePropertyNames.has(key))
            .map(([key, value]) => ({
                key,
                value: value as string | null
            }));
        return copySource;
    }
}
